import React from 'react';

export default props => (
    <svg viewBox="0 0 38 38" {...props}>
        <path fill="#FFF"
              d="M26 18h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17v-6c0-1.66-1.34-3-3-3s-3 1.34-3 3v.18l5.98 5.99zM11.27 10L10 11.27l6.01 6.01V18c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H12c0 3.41 2.72 6.23 6 6.72V28h2v-3.28c.91-.13 1.77-.45 2.54-.9L26.73 28 28 26.73 11.27 10z"/>
    </svg>
);